import { useMutation } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient, ApiError } from '@utils';

export const useForgotPassword = (callback: () => void) => {
  return useMutation<void, ApiError, string>({
    mutationFn: async (email: string) => {
      const result = await apiClient.user.forgotPassword.mutation({ body: email });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      callback();
    },
    onError: (error) => {
      showErrorToast(error, `Forgot password failed!`);
    },
  });
};
